import { ASSIST_MIGRATION_SELF_SERVE_FILTER_FIELD } from 'constants/assist/assistMigration';
import type { ToAssistMigrationAppliedFilters } from 'types/assist/toAssistMigrationAppliedFilters';

export const toAssistMigrationAppliedFilters: ToAssistMigrationAppliedFilters = (model) =>
  model.items.reduce<Record<string, string>>((filters, item) => {
    const isSupportedField =
      item.field.startsWith('bs_') ||
      item.field === 'isLaundroworksConnected' ||
      item.field === ASSIST_MIGRATION_SELF_SERVE_FILTER_FIELD;

    if (!isSupportedField || item.value === undefined || item.value === '') {
      return filters;
    }

    filters[item.field] = String(item.value);
    return filters;
  }, {});
